import { FeatureTelegramStatsView } from './telegram-stats';
import { TelegramStatsProvider } from './telegram-stats.provider';

export const FeatureTelegramStats = () => (
   <TelegramStatsProvider>
      <FeatureTelegramStatsView />
   </TelegramStatsProvider>
);
